// File generated by MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
import { ResultItemDto, ResultItemDtoFormGroup } from './ResultItemDto';

export class PagedResultItemDto<T> extends ResultItemDto<T> {
}

export interface PagedResultItemDtoFormGroup<T> extends ResultItemDtoFormGroup<T> {
}
